import { render, staticRenderFns } from "./laonlttlay.vue?vue&type=template&id=06468d1a&"
import script from "./laonlttlay.vue?vue&type=script&lang=js&"
export * from "./laonlttlay.vue?vue&type=script&lang=js&"
import style0 from "./laonlttlay.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports